<template>
    <div class="row">
      <div class="col-md-10 col-md-offset-1" >
        <div class="form-group">
          <h4 v-if="showAddressAndSite" >{{ this.$store.state.site.name }}<br>
            <small> {{this.$store.state.site.address}}</small>
            <hr>
          </h4>
        </div>
        <h4>
          <div class="box"><span class="text-center">{{ labName + ' ' + computeCaption(fields_en['disclaimer'], $store.state.lang.value.toLowerCase()) }}</span></div>
        </h4>
        <label class="control-label">
        </label>
        <p v-html="disclaimer_text">
        </p>
        <hr>
        <div class="general-active-section p-2" :class="validatedSectionClass">
        <p-checkbox v-model="model.agreed" name="agreed" class="required"
                    v-validate="modelValidations.agreed"
        > {{ computeCaption(fields_en['i_agree'], $store.state.lang.value.toLowerCase()) }} </p-checkbox>
        <small class="text-danger" v-show="agreed.invalid">
          {{ getError('agreed') }}
        </small>
        <hr>
        <div v-if="allow_signature" v-touch:end="checkValidationsDisclaimer" v-on:mouseleave='checkValidationsDisclaimer'>
          <label class="control-label required">
            {{ computeCaption(fields_en['please_sign'], $store.state.lang.value.toLowerCase()) }}
          </label>
          <VueSignaturePad class="signature" id="signature-disclaimer-results" width="100%" height="200px" ref="signaturePad" :options="{onBegin: () => {$refs.signaturePad.resizeCanvas()}}" />
          <div class="flex-end">
            <br>
            <el-button plain @click="clear">{{ computeCaption(fields_en['clear'], $store.state.lang.value.toLowerCase()) }}</el-button>
          </div>
          <br>
          <small class="text-danger" v-if="!model.signature && submit">
            {{ computeCaption(fields_en['please_sign_error'], $store.state.lang.value.toLowerCase()) }}
          </small>
        </div>
        </div>
      </div>
    </div>
</template>

<script>
  import {mapFields} from 'vee-validate'
  import { Button } from 'element-ui'
  import {CheckResults} from '../../../../../utils/CheckResults.js'
  import {FormatterUtils} from '../../../../../utils/Formatter.js'
  import {TranslationsUtils} from '../../../../../utils/Translations'
  export default {
    components: {
      [Button.name]: Button
    },
    mixins: [FormatterUtils, CheckResults, TranslationsUtils],
    data () {
      return {
        validatedSectionClass: '',
        validationObject: {
          signatureValidation: false,
          agreedValidation: false
        },
        submit: false,
        skip_security_code: this.isTrue(this.$store.state.configs.SKIP_SECURITY_CODE),
        allow_signature: this.$store.state.configs.ALLOW_SIGNATURE_RESULTS_DISCLAIMER,
        labName: this.$store.state.configs.LAB_NAME,
        showAddressAndSite: this.isTrue(this.$store.state.configs.SHOW_ADDRESS_DISCLAIMER),
        security_code_by_text: this.isTrue(this.$store.state.configs.SECURITY_CODE_BY_TEXT),
        security_code_by_email: this.isTrue(this.$store.state.configs.SECURITY_CODE_BY_EMAIL),
        fields_en: {
          clear: 'Clear',
          i_agree: 'I agree',
          disclaimer: 'Disclaimer',
          please_sign: 'Patient or Legal Guardian Signature',
          please_sign_error: 'Please Sign!'
        },
        model: {
          agreed: false,
          signature: ''
        },
        text: '',
        modelValidations: {
          agreed: {
            required: true
          }
        }
      }
    },
    methods: {
      checkValidationsDisclaimer () {
        if (this.allow_signature) {
          this.save()
        }
        if (this.$refs.signaturePad.isEmpty()) {
          this.validationObject.signatureValidation = false
        } else {
          this.validationObject.signatureValidation = true
        }
      },
      clear () {
        this.$refs.signaturePad.clearSignature()
        this.checkValidationsDisclaimer()
      },
      save () {
        const { data } = this.$refs.signaturePad.saveSignature()
        this.model.signature = data
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      async validate () {
        if (this.allow_signature) {
          this.save()
        }
        this.submit = true
        if (!this.model.agreed) {
          this.$validator.errors.add({field: 'agreed', msg: this.computeCaption('Please accept!', this.$store.state.lang.value.toLowerCase())})
          let field = this.$validator._resolveField('agreed')
          field.setFlags({invalid: true})
        }
        if (this.allow_signature && !this.model.signature || !this.model.agreed) {
          return false
        }
        if (this.skip_security_code) {
          await this.getResults(this.$store.state.results.user.firstName, this.$store.state.results.user.lastName)
        } else {
          if (!(this.security_code_by_text && this.security_code_by_email)) {
            let sendMethod
            if (this.security_code_by_text) {
              this.$store.state.results.user['sendTo'] = this.$store.state.results.user.phone
              sendMethod = 'phone'
            } else {
              this.$store.state.results.user['sendTo'] = this.$store.state.results.user.email
              sendMethod = 'email'
            }
            let form = {
              code: this.$store.state.results.user.code,
              send_method: sendMethod
            }
            await this.generateSecurityCode(form)
          }
        }
        return this.$validator.validateAll()
      }
    },
    computed: {
      disclaimer_text () {
        if (this.$store.state.lang.value.toLowerCase() === 'es' && this.$store.state.results.site.disclaimer_es) {
          return this.$store.state.results.site.disclaimer_es
        } else {
          if (this.$store.state.lang.value.toLowerCase() === 'zh' && this.$store.state.results.site.disclaimer_zh) {
            return this.$store.state.results.site.disclaimer_zh
          } else {
            if (this.$store.state.lang.value.toLowerCase() === 'en' && this.$store.state.results.site.disclaimer) {
              return this.$store.state.results.site.disclaimer
            }
          }
        }
      },
      ...mapFields(['agreed'])
    },
    beforeMount () {
    },
    watch: {
      'model.agreed': {
        handler: function (after, before) {
          if (this.model.agreed) {
            this.validationObject.agreedValidation = true
          } else {
            this.validationObject.agreedValidation = false
          }
        }
      },
      'model.signature': {
        handler: function (after, before) {
          if (this.model.signature) {
            this.validationObject.signatureValidation = true
          } else {
            this.validationObject.signatureValidation = false
          }
        }
      },
      'validationObject': {
        handler: function (before, after) {
          if (!this.allow_signature) {
            this.validationObject.signatureValidation = true
          }
          if (Object.values(this.validationObject).every(field => field === true)) {
            this.validatedSectionClass = 'validated-section-class'
          } else {
            this.validatedSectionClass = 'invalid-section-class'
          }
        },
        deep: true
      },
      '$store.state.configs.SKIP_SECURITY_CODE': {
        handler: function (value) {
          if (value !== undefined) {
            this.skip_security_code = value
          }
        }
      }
    }
  }
</script>

<style scoped>
  .box {
    margin-top: 20px;
    text-align: center;
  }
  .p-2{
    padding:20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Results/Wizard/DisclaimerStep.vue